<template>
  <Paginate
      v-model="internalPage"
      :page-count="pageCount"
      :click-handler="emitChange"
      prev-text=""
      next-text=""
      container-class="pagination"
      page-class="page-item"
      :page-range="pageRange"
  />
</template>

<script>
import Paginate from 'vuejs-paginate-next';

export default {
  name: 'Pagination',
  components: { Paginate },

  props: {
    pageCount:  { type: Number, required: true },
    modelValue: { type: Number, default: 1 }     // v-model из родителя
  },

  emits: ['update:modelValue', 'page-changed'],

  data() {
    return {
      windowWidth: 0
    };
  },

  computed: {
    internalPage: {
      get()  { return this.modelValue; },
      set(v) { this.$emit('update:modelValue', v); }
    },
    pageRange() {
      return this.windowWidth <= 768 ? 2 : 15;
    }
  },

  mounted() {
    this.windowWidth = window.innerWidth;
    window.addEventListener('resize', this.onResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize);
  },

  methods: {
    onResize() { this.windowWidth = window.innerWidth; },
    emitChange(page) {
      this.$emit('page-changed', page);   // родитель ловит @page-changed="..."
    }
  }
};
</script>